export default __webpack_public_path__ + "static/media/package_16.2705d120.png";